/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeBase,
  UnifiedClassTypeBaseOptional,
  UnifiedClassTypeBaseMetaI,
  UnifiedClassTypeBaseTrackedI,
} from "./unified-class-type-base";
import {
  UnifiedClassTypeBaseTracked,
  UnifiedClassTypeBaseMeta,
} from "./unified-class-type-base";

/**
 *
 * @export
 * @interface WithClassType
 */
export interface WithClassTypeOptional {
  /**
   *
   * @type {UnifiedClassTypeBase}
   * @memberof WithClassType
   */
  typeId?: UnifiedClassTypeBaseOptional;
}

export interface WithClassType extends WithClassTypeOptional {
  /**
   *
   * @type {UnifiedClassTypeBase}
   * @memberof WithClassType
   */
  typeId?: UnifiedClassTypeBase;
}

export interface WithClassTypeTrackedI {
  /**
   *
   * @type {UnifiedClassTypeBase}
   * @memberof WithClassType
   */
  typeId?: UnifiedClassTypeBaseTrackedI;
  typeIdIsSet: boolean;
}

transformDatesMap.set("WithClassType", function (model: WithClassType) {
  const transformDatestypeId = transformDatesMap.get("UnifiedClassTypeBase");
  if (transformDatestypeId && model.typeId) {
    transformDatestypeId(model.typeId);
  }
});

export type WithClassTypeMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  typeId: PropertyMeta<UnifiedClassTypeBaseMetaI>;
}>;

export var WithClassTypeMeta: WithClassTypeMetaI = {} as WithClassTypeMetaI;
WithClassTypeMeta = typeMeta("WithClassType", {
  typeId: propertyMeta("typeId", false, false, false, UnifiedClassTypeBaseMeta),
});

const metaI = WithClassTypeMeta;

registerMeta(() => {});

export class WithClassTypeTracked implements WithClassTypeTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  typeId__I?: UnifiedClassTypeBaseTracked = undefined;
  typeIdIsSet: boolean = false;
  set typeId(v: undefined | UnifiedClassTypeBaseTracked) {
    if (v !== undefined) {
      this.typeId__I = v;
      this.typeIdIsSet = true;
    } else {
      this.typeId__I = v || undefined;
      this.typeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeId() {
    return this.typeId__I;
  }
  constructor(config?: WithClassTypeOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.typeId?.setIds();
  }
  assignFrom(
    config: WithClassTypeOptional,
    options?: AssignOptions,
  ): WithClassTypeTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.typeId && this.typeIdApplyFilter(optionsRequired.filter)) {
      this.typeId = new UnifiedClassTypeBaseTracked(config.typeId, options);
      if (optionsRequired.unassign) this.typeIdIsSet = false;
      else this.typeIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithClassTypeTrackedI {
    const cloned = {} as WithClassTypeTrackedI;
    if (
      this.typeIdIsSetDeep() &&
      this.typeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIdIsSet = true;
      cloned.typeId = this.typeId?.removeUnset(filter);
    } else {
      //cloned.typeIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithClassTypeTrackedI {
    if (!this.typeIdApplyFilter(filter)) this.typeIdIsSet = false;
    this.typeId?.unassignAll(filter);

    return this;
  }
  typeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithClassTypeMeta.typeId,
      WithClassTypeMeta,
      this.typeId,
      this,
    );
  }
  typeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIdIsSet && this.typeIdApplyFilter(filter)) return true;
    return this.typeId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.typeIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
